import { render } from "./workList.vue?vue&type=template&id=94b1c1d4&scoped=true&ts=true"
import script from "./workList.vue?vue&type=script&lang=ts"
export * from "./workList.vue?vue&type=script&lang=ts"

import "./workList.vue?vue&type=style&index=0&id=94b1c1d4&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b1c1d4"]])

export default __exports__